export default "__VITE_ASSET__b136487e__"